<template>
  <div class="body">
    <!-- 换货包裹跟进 -->
    <baseBreadcrumb :page="$t('message.followUpTheReplacementPackage')"
      :menu="$t('message.returnAndExchangeLogistics')" />
    <div class="body">
      <el-tabs v-model="datas.status" type="card" @tab-click="search">
        <!-- 全部 -->
        <el-tab-pane :label="$t('message.all')" name="99"></el-tab-pane>
        <!-- 等待卖家返件 888 -->
        <el-tab-pane :label="$t('message.waitForTheSellerToReturnTheGoods') + `(${tabs[1].num})`"
          name="20"></el-tab-pane>
        <!-- 换货包裹待签收 888  -->
        <el-tab-pane :label="$t('message.replacementPackageToBeSigned') + `(${tabs[2].num})`" name="21"></el-tab-pane>
        <!--换货包裹已签收 -->
        <el-tab-pane :label="$t('message.theReplacementPackageHasBeenReceived')" name="22"></el-tab-pane>
        <!--换货取消 -->
        <el-tab-pane :label="$t('message.theReplacementIsCancelled')" name="23"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->
      <div class="search">
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')"></el-input>
        </div>


        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" @click="search">{{
            $t("message.search")
          }}</el-button>
          <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  退换货编号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeNumber')" prop="refund_sn" width="150px">
          </el-table-column>
          <!-- 退件扫描时间 -->
          <el-table-column align="center" :label="$t('message.returnScanTime')" prop="scan_at" width="100">
            <template slot-scope="scope">
              {{
                scope.row.order_purchase_refund_detail_express[0].scan_at
              }}
            </template>
          </el-table-column>
          <!--  采购员-->
          <el-table-column align="center" :label="$t('message.buyer')" prop="g_admin.realname">
          </el-table-column>
          <!--  配货员-->
          <el-table-column align="center" :label="$t('message.distributionMember')" prop="p_admin.realname">
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')" prop="" width="170px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank"
                  style="color: #fa5058">{{ scope.row.order_sn }}</router-link>
              </p>
              <!-- <p>
                {{
                  scope.row.order_purchase_refund_detail.order_purchase.realname
                }}
              </p> -->
            </template>
          </el-table-column>
          <!--  交易号-->
          <el-table-column align="center" :label="$t('message.transactionNumber')" prop="purchase_no">
          </el-table-column>
          <!--  退换货类别-->
          <!-- <el-table-column align="center" :label="$t('message.typeOfReturnOrExchange')" prop="type_name">
            <template slot-scope="scope">
              <span :style="{
                color: scope.row.refund_type == 1 ? '#FA5058' : '#2C96E7',
              }">{{ scope.row.type_name }}</span>
            </template>
          </el-table-column> -->
          <!--  退换货数量-->
          <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')" prop="refund_num_total">
          </el-table-column>
          <!--  商品明细-->
          <el-table-column align="center" :label="$t('message.detailsOfGoods')" prop="rowNumber">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="look(scope.row)">{{
                $t("message.look")
              }}</el-button>
            </template>
          </el-table-column>
          <!--  退换货物流号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeLogisticsNumber')" prop="rowNumber"
            width="150">
            <template slot-scope="scope">
              <div class="template">
                <div v-for="(express, expressIndex) in scope.row
                  .order_purchase_refund_detail_express" :key="expressIndex">

                  <div>
                    <el-popover placement="left" title="国内物流:" width="400" trigger="click">
                      <el-timeline v-if="activities != false">
                        <el-timeline-item v-for="(activity, index) in activities" :key="index"
                          :timestamp="activity.time" :color="activity.color" placement="top">
                          {{ activity.context }}
                        </el-timeline-item>
                      </el-timeline>
                      <p v-else> 暂无物流信息 </p>
                      <p slot="reference">
                        <span class="WL">
                          <a href="javascript:;" class="a-link" @click="getTrace
                            (express.refund_express_no)"> {{ express.refund_express_no }}</a>
                          <i class="el-icon-copy-document" @click.stop="copy(express.refund_express_no)"></i></span>
                      </p>
                    </el-popover>
                  </div>
                  {{ express.scan_at }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!--  返件单号-状态-->
          <el-table-column align="center" :label="$t('message.returnTrackingNumber_Status')" prop="rowNumber"
            width="200">
            <template slot-scope="scope">
              <div class="template">
                <div v-for="(express, expressIndex) in scope.row
                  .order_purchase_refund_detail_return" :key="expressIndex">

                  <div>
                    <el-popover placement="left" title="国内物流:" width="400" trigger="click">
                      <el-timeline v-if="activities != false">
                        <el-timeline-item v-for="(activity, index) in activities" :key="index"
                          :timestamp="activity.time" :color="activity.color" placement="top">
                          {{ activity.context }}
                        </el-timeline-item>
                      </el-timeline>
                      <p v-else> 暂无物流信息 </p>
                      <p slot="reference">
                        <span class="WL">
                          <a href="javascript:;" class="a-link" @click="getTrace
                            (express.return_express_no)"> {{ express.return_express_no }}</a>
                          <i class="el-icon-copy-document" @click.stop="copy(express.return_express_no)"></i></span>
                      </p>
                    </el-popover>
                  </div>
                  <span :style="{ color: express.scan_at ? '#15AD3C' : '#FFA21D' }">
                    {{ express.scan_at ? "签收 " : "未签收" }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="110px">
            <template slot-scope="scope">
              <!-- 添加返件单号 -->
              <p>
                <el-button size="small" type="success" class="primary" @click="addTheReturnTrackingNumber(scope.row)"
                  v-if="isAuth(290)">{{
                    $t("message.addTheReturnTrackingNumber") }}</el-button>
              </p>
              <!-- 换货取消 -->
              <p>
                <el-button size="small" type="success" class="dark" @click="cancelExchange(scope.row.refund_sn)"
                  v-if="isAuth(291)">{{
                    $t("message.theReplacementIsCancelled") }}</el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看商品详情 -->
    <detailsGoodsDialogVisible :list="itemData" v-if="detailsGoodsDialogVisible" />
    <!-- 退换货编辑 -->
    <returnAndExchangeEditor v-if="returnAndExchangeEditorDialogVisible" :itemData="itemData" :type="3" />
  </div>
</template>
<script>
import detailsGoodsDialogVisible from "../components/goodsDetails";
import returnAndExchangeEditor from "../components/returnAndExchangeEditor";
export default {
  data() {
    return {
      activities: [],
      val: "",
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 }, { num: 0 }, { num: 0 },],
      tableData: [],
      show: true,
      datas: {
        page: 1,
        pageSize: 10,
        status: "99",
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      },
      total: 0,
      detailsGoodsDialogVisible: false,
      returnAndExchangeEditorDialogVisible: false,
      itemData: [],
    };
  },
  components: {
    detailsGoodsDialogVisible,
    returnAndExchangeEditor,
  },
  created() {
    this.purchaseRefundListNum()
    this.refundList();
  },
  methods: {
    refundList() {
      this.$api.signInApi.refundList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.order_purchase_refund_detail_express = [];
          item.order_purchase_refund_detail_return = [];
          item.order_purchase_refund_detail.forEach((items) => {
            item.order_purchase_refund_detail_express = [
              ...item.order_purchase_refund_detail_express,
              ...items.order_purchase_refund_detail_express,
            ];
            item.order_purchase_refund_detail_return = [
              ...item.order_purchase_refund_detail_return,
              ...items.order_purchase_refund_detail_return,
            ];
          });
          // 数组去重
          var hash = {};
          item.order_purchase_refund_detail_express = item.order_purchase_refund_detail_express.reduce(function (items, next) {
            hash[next.refund_express_no]
              ? ""
              : (hash[next.refund_express_no] = true && items.push(next));

            return items;
          }, []);
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(this.tableData);
      });
    },
    //退换货列表数量统计
    purchaseRefundListNum() {
      this.$api.tabTotalApi.purchaseRefundListNum().then(res => {
        this.tabs = res.data
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.refundList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        status: 99,
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      };
      this.refundList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.refundList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.refundList();
    },
    // 查看
    look(item) {
      this.itemData = JSON.parse(
        JSON.stringify(item.order_purchase_refund_detail)
      );
      this.detailsGoodsDialogVisible = true;
    },
    // 添加返件单号
    addTheReturnTrackingNumber(item) {
      this.itemData = JSON.parse(JSON.stringify(item));

      this.returnAndExchangeEditorDialogVisible = true;
    },

    // -换货取消
    cancelExchange(refund_sn) {
      this.$confirm(
        this.$t("message.isTheReplacementIsCancelled"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.cancelExchange({ refund_sn }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
    //快递100物流轨迹-查询
    getTrace(expressNo) {
      this.$api.getTrace({ expressNo }).then(res => {
        if (res.data != false) {
          res.data.trace[0].color = '#B4272D'
        }
        this.activities = res.data.trace
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-top: 15px;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
    }

    .primary {
      padding: 9px 0;
    }
  }
}
</style>
